import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { POLSUMMARY_INIT_LOADING, POLSUMMARY_INIT_SUCCESS, POLSUMMARY_INIT_FAIL, PREMINSTALBILL_SAVE_LOADING, PREMINSTALBILL_SAVE_SUCCESS, PREMINSTALBILL_SAVE_FAIL } from '@/store/types'

export const summary = {
  async policySummaryInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policySummary
    commit(POLSUMMARY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLSUMMARY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLSUMMARY_INIT_FAIL, extractMessages(error))
    }
  },
  async savePremInstalBill ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policySummarySettings.menu.savePremInstalBill
    if (apiUrl) {
      commit(PREMINSTALBILL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(PREMINSTALBILL_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(PREMINSTALBILL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(PREMINSTALBILL_SAVE_FAIL, generateManualSaveError(['Fail to save Instalment Details']))
        }
        return false
      }
    } else {
      commit(PREMINSTALBILL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
